import { Component, computed, input, output } from '@angular/core';
import { DatetimePipe } from '../../../../../../pipes/dates/datetime.pipe';
import { IconComponent } from '../../../../../ui/icon/icon.component';
import { TranslatePipe } from '../../../../../../pipes/translate/translate.pipe';
import { NgClass } from '@angular/common';
import { VersionType } from '../../../../../../enums/version-type';

@Component({
  selector: 'bizz-compare-button',
  standalone: true,
  imports: [
    DatetimePipe,
    IconComponent,
    TranslatePipe,
    NgClass
  ],
  templateUrl: './compare-button.component.html',
  styleUrls: ['./compare-button.component.scss']
})
export class CompareButtonComponent {

  public onClick = output<MouseEvent>();

  public versionType = input<VersionType>();
  public version = input<string | unknown>();
  public versionDate = input.required<unknown>();
  public archiveDate = input<unknown>();
  public isSelected = input<boolean>(false);
  public versionDateStr = computed(() => this.versionDate() ?? '');
  public archiveDateStr = computed(() => this.archiveDate() ?? '');


  public onButtonClick(event: MouseEvent): void {
    event.preventDefault();
    this.onClick.emit(event);
  }

  protected readonly VersionType = VersionType;
}
